import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import { CloseButton, } from '../../../CloseButton/CloseButton';
const baseStyles = ({ theme }) => css `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${theme.spacings.giga};
`;
const noHeadlineStyles = ({ children }) => Array.isArray(children) &&
    !children[0] &&
    css `
    justify-content: flex-end;
  `;
const CardHeaderContainer = styled('header')(baseStyles, noHeadlineStyles);
const closeButtonStyles = ({ theme }) => css `
  margin-top: -${theme.spacings.byte};
  margin-right: -${theme.spacings.mega};
  margin-bottom: -${theme.spacings.byte};
`;
const CardHeaderCloseButton = styled(CloseButton)(closeButtonStyles);
/**
 * Header used in the Card component. Used for styling and alignment
 * purposes only.
 */
export const CardHeader = ({ onClose, children, closeButtonLabel, tracking, ...props }) => (_jsxs(CardHeaderContainer, { ...props, children: [children, onClose && closeButtonLabel && (_jsx(CardHeaderCloseButton, { onClick: onClose, label: closeButtonLabel, tracking: tracking ? { component: 'close-button', ...tracking } : undefined }, void 0))] }, void 0));
